import { Stack, Text } from '@mantine/core';
import React from 'react';

export const Section = ({
    title,
    description,
    children,
    boxed = false,
}: {
    title?: string;
    description?: string;
    children: React.ReactNode;
    /** Bordered panel so the block doesn't blend with neighboring fields. */
    boxed?: boolean;
}) => (
    <Stack
        gap='sm'
        p={boxed ? 'md' : undefined}
        style={
            boxed
                ? {
                      border: '1px solid var(--mantine-color-gray-3)',
                      borderRadius: 'var(--mantine-radius-md)',
                      background: 'var(--mantine-color-body)',
                  }
                : undefined
        }
    >
        {(title || description) && (
            <Stack
                gap={2}
                pb={boxed ? 4 : undefined}
                style={
                    boxed
                        ? {
                              borderBottom: '1px solid var(--mantine-color-gray-2)',
                              marginBottom: 4,
                          }
                        : undefined
                }
            >
                {title && (
                    <Text
                        size={boxed ? 'xs' : 'sm'}
                        fw={700}
                        tt={boxed ? 'uppercase' : undefined}
                        c={boxed ? 'dimmed' : undefined}
                        style={boxed ? { letterSpacing: '0.04em' } : undefined}
                    >
                        {title}
                    </Text>
                )}
                {description && (
                    <Text size='xs' c='dimmed'>
                        {description}
                    </Text>
                )}
            </Stack>
        )}
        {children}
    </Stack>
);

export const FieldHint = ({ children }: { children: React.ReactNode }) => (
    <Text size='xs' c='dimmed'>
        {children}
    </Text>
);
